import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import ReactHtmlParser from 'react-html-parser';
import Loader from "../../component/loader";

function SellerWriteup() {
  const [writeupData, setWriteupData] = useState();
  const [loader, setLoader] = useState();

  const writeupFetch = async () => {
    setLoader(true);
    const response = await axios.get(`/user/setting/sellerWriteup/view`)
      .then((response) => {
        console.log('writeup data', response);
        if (response.data) {
          setWriteupData(response.data.data.desc)
        }
        setLoader(false);
      }).catch((errors) => {
        console.log('writeup data errors', errors.response);
        setLoader(false);
      })
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    writeupFetch();
  }, []);

  return (
    <div className="responsive-xs responsive-sm">
      {/* Header */}
      <div className="header">
        <div style={{ width: "15%" }}>
          <Link to="/home">
            <img src="./logo.webp" className="site-logo" alt="logo" />
          </Link>
        </div>
      </div>

      {loader && loader ? <div style={{ height: '100vh' }}> <Loader /></div>
        :
        <div className="policy">
          <div className="container my-5">
            <h4 className="text-center">Seller Guide</h4>
            {ReactHtmlParser(writeupData && writeupData)}
          </div>
        </div>
      }

      {/* Footer */}
      <div className="footer">
        <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
          <p> <Link style={{ color: 'white', textDecoration: 'none' }} to="/policy"> Seller Policy</Link></p>
          <p> <Link style={{ color: 'white', textDecoration: 'none' }} to="/sellerWriteup"> Seller Guide</Link></p>
        </div>
        <p style={{ marginTop: 15 }}>©2022 AiviMart. All rights reserved</p>
      </div>
    </div>
  );
}

export default SellerWriteup;
